<template>
    <div class="modal-card ">
        <b-loading  :active.sync="isFullScreenLoading" ></b-loading>
                <header class="modal-card-head"  >

                    <p class="modal-card-title "   >UA Management</p>
 

                </header>
                <section class="modal-card-body"  >
                     
                   <b-tabs v-model="activeTab" size="is-large" >
                        <b-tab-item label="Cast" >
                            <nav class="level is-mobile">
                                <div class="level-left">
                                    <div class="level-item">
                                        <b-button
                                                  type="is-success"
                                                  icon-left="plus"
                                                  @click="addNewCast">
                                            Add New Cast
                                        </b-button>
                                    </div>
                                    <div class="level-item">
                                         <b-button
                                            type="is-primary"
                                            icon-left="refresh"
                                            @click="loadCastData"
                                    >Refresh Cast</b-button>
                                    </div>

                                </div>
                                <div class="level-right">

                                </div>
                            </nav>


                            <b-table
                                    :data="isEmpty ? [] : castData"
                                    bordered
                                    striped
                                    narrowed
                                    hoverable
                                    focusable
                                    :loading = "isCastLoading"
                                    mobile-cards>
                                <b-table-column   label="Name" v-slot="props" width="40%">
                                    {{ props.row.name }}
                                </b-table-column>
                                <b-table-column   label="Status" v-slot="props">
                                       <b-icon
                                            :icon="props.row.enabled ? `check-circle` : `stop-circle` "
                                            :type="props.row.enabled ? `is-success` : `is-danger` "
                                            size="is-medium">
                                      </b-icon>

                                      {{props.row.enabled ? 'ใช้งาน' : 'ยกเลิก'}}
                                </b-table-column>

                                <b-table-column   label="#"     centered v-slot="props">
                                    <b-button type="is-warning"  icon-left="pencil" @click="editCast(props.row)">Edit</b-button>
                                </b-table-column>


                                <template slot="empty">
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p>
                                                <b-icon
                                                        icon="emoticon-sad"
                                                        size="is-large">
                                                </b-icon>
                                            </p>
                                            <p>Nothing here.</p>
                                        </div>
                                    </section>
                                </template>
                            </b-table>



                        </b-tab-item>







                        <b-tab-item label="Cystal">
                           

                           <nav class="level is-mobile">
                                <div class="level-left">
                                    <div class="level-item">
                                        <b-button
                                                  type="is-success"
                                                  icon-left="plus"
                                                  @click="addNewCystal">
                                            Add New Cystal
                                        </b-button>
                                    </div>
                                    <div class="level-item">
                                         <b-button
                                            type="is-primary"
                                            icon-left="refresh"
                                            @click="loadCystalData"
                                    >Refresh Cystal</b-button>
                                    </div>

                                </div>
                                <div class="level-right">

                                </div>
                            </nav>


                            <b-table
                                    :data="isEmpty ? [] : cystalData"
                                    bordered
                                    striped
                                    narrowed
                                    hoverable
                                    focusable
                                    :loading = "isCystalLoading"
                                    mobile-cards>
                                <b-table-column   label="Name" v-slot="props" width="40%">
                                    {{ props.row.name }}
                                </b-table-column>
                                <b-table-column   label="Status" v-slot="props">
                                       <b-icon
                                            :icon="props.row.enabled ? `check-circle` : `stop-circle` "
                                            :type="props.row.enabled ? `is-success` : `is-danger` "
                                            size="is-medium">
                                      </b-icon>

                                      {{props.row.enabled ? 'ใช้งาน' : 'ยกเลิก'}}
                                </b-table-column>

                                <b-table-column   label="#"     centered v-slot="props">
                                    <b-button type="is-warning"  icon-left="pencil" @click="editCystal(props.row)">Edit</b-button>
                                </b-table-column>


                                <template slot="empty">
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p>
                                                <b-icon
                                                        icon="emoticon-sad"
                                                        size="is-large">
                                                </b-icon>
                                            </p>
                                            <p>Nothing here.</p>
                                        </div>
                                    </section>
                                </template>
                            </b-table>




                        </b-tab-item>










                        <b-tab-item label="Epith">
                             <nav class="level is-mobile">
                                <div class="level-left">
                                    <div class="level-item">
                                        <b-button
                                                  type="is-success"
                                                  icon-left="plus"
                                                  @click="addNewEpith">
                                            Add New Epith
                                        </b-button>
                                    </div>
                                    <div class="level-item">
                                         <b-button
                                            type="is-primary"
                                            icon-left="refresh"
                                            @click="loadEpithData"
                                    >Refresh Epith</b-button>
                                    </div>

                                </div>
                                <div class="level-right">

                                </div>
                            </nav>


                            <b-table
                                    :data="isEmpty ? [] : epithData"
                                    bordered
                                    striped
                                    narrowed
                                    hoverable
                                    focusable
                                    :loading = "isEpithLoading"
                                    mobile-cards>
                                <b-table-column   label="Name" v-slot="props" width="40%">
                                    {{ props.row.name }}
                                </b-table-column>
                                <b-table-column   label="Status" v-slot="props">
                                       <b-icon
                                            :icon="props.row.enabled ? `check-circle` : `stop-circle` "
                                            :type="props.row.enabled ? `is-success` : `is-danger` "
                                            size="is-medium">
                                      </b-icon>

                                      {{props.row.enabled ? 'ใช้งาน' : 'ยกเลิก'}}
                                </b-table-column>

                                <b-table-column   label="#"     centered v-slot="props">
                                    <b-button type="is-warning"  icon-left="pencil" @click="editEpith(props.row)">Edit</b-button>
                                </b-table-column>


                                <template slot="empty">
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p>
                                                <b-icon
                                                        icon="emoticon-sad"
                                                        size="is-large">
                                                </b-icon>
                                            </p>
                                            <p>Nothing here.</p>
                                        </div>
                                    </section>
                                </template>
                            </b-table>
                        </b-tab-item>
                   </b-tabs>    





                </section>
                <footer class="modal-card-foot">

                    <b-button size="is-medium" type="is-danger"
                              icon-left="close" @click="close">
                        Close
                    </b-button>
                </footer>


               <AddEditCastCysEpith
                    v-if="isAddEditCastCysEpithShowing"
                    :type_AddEditCastCysEpith="type_AddEditCastCysEpith"
                    :dataAddEditCastCysEpithToEdit = "dataAddEditCastCysEpithToEdit"
                    :mode = "addEditCastCysEpithMode"
                    @close="closeAddEditCastCysEpith"
                    @closeWithDataChange = "closeAddEditCastCysEpith_WithChange"
                />



    </div>
</template>

<script>

import axios from "axios";
import { getBaseURLforBackEnd ,getConfigAxios  }  from '@/utils.js'
import { mapState } from "vuex";

import AddEditCastCysEpith from '../UA/AddEditCastCysEpith.vue'

export default {
    name : "UADashboard",
    created() {
        const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
            this.close()

            next(false)
        })

        this.$once('hook:destroyed', () => {
            unregisterRouterGuard()
        })
    },
    components:{
        AddEditCastCysEpith,
    },
    props:{
            isComponentModalActive : Boolean
    },
    computed:{
          ...mapState({
                access_token : state => state.master_data.access_token,
            }) 
    },
    methods:{
        closeAddEditCastCysEpith(){
            this.isAddEditCastCysEpithShowing = false
        },
        closeAddEditCastCysEpith_WithChange(payload){
            if(payload == 'cast'){
               this.loadCastData()
            }
            if(payload == 'cystal'){
               this.loadCystalData()  
            }
            if(payload == 'epith'){
               this.loadEpithData()   
            }
            this.isAddEditCastCysEpithShowing = false
        },






        loadCastData(){
                this.isCastLoading = true
                const datTo = {   
                                    "admin": true 
                               }
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/get_ua_cast_mst`,datTo,getConfigAxios())
                        .then((res)=>{
                              this.castData = res.data
                              this.isCastLoading = false
                        })
                        .catch((err)=>{
                            this.isCastLoading = false
                            this.$buefy.dialog.alert({
                                title: 'Error',
                                message: `${err}`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'alert-circle',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                            this.$router.push('/login')
                                .catch(()=>{});
                        })
        },
        addNewCast(){
            this.dataAddEditCastCysEpithToEdit = Object.assign({},
                                                {   
                                                     "id" : null,
                                                     "name": "" ,
                                                     "enabled" : true 
                                                }
                                          )
            this.addEditCastCysEpithMode = 0 // 0 == add , 1 == edit 
            this.type_AddEditCastCysEpith = 'cast' // 'cast','cystsl','epith
            this.isAddEditCastCysEpithShowing = true
        },
        editCast(payload){
            this.dataAddEditCastCysEpithToEdit = Object.assign({},
                                                {   
                                                     "id" : payload.id,
                                                     "name": payload.name,
                                                     "enabled" : payload.enabled
                                                }
                                          )
            this.addEditCastCysEpithMode = 1 // 0 == add , 1 == edit 
            this.type_AddEditCastCysEpith = 'cast' // 'cast','cystsl','epith
            this.isAddEditCastCysEpithShowing = true
        },





        loadCystalData(){
                this.isCystalLoading = true
                const datTo = {   
                                    "admin": true 
                               }
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/get_ua_cystal_mst`,datTo,getConfigAxios())
                        .then((res)=>{
                              this.cystalData = res.data
                              this.isCystalLoading = false
                        })
                        .catch((err)=>{
                            this.isCystalLoading = false
                            this.$buefy.dialog.alert({
                                title: 'Error',
                                message: `${err}`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'alert-circle',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                            this.$router.push('/login')
                                .catch(()=>{});
                        })
        },
        addNewCystal(){
                this.dataAddEditCastCysEpithToEdit = Object.assign({},
                                                                            {   
                                                                                "id" : null,
                                                                                "name": "" ,
                                                                                "enabled" : true 
                                                                            }
                                                                    )
                this.addEditCastCysEpithMode = 0 // 0 == add , 1 == edit 
                this.type_AddEditCastCysEpith = 'cystal' // 'cast','cystal','epith
                this.isAddEditCastCysEpithShowing = true
        },
        editCystal(payload){
                this.dataAddEditCastCysEpithToEdit = Object.assign({},
                                                {   
                                                     "id" : payload.id,
                                                     "name": payload.name,
                                                     "enabled" : payload.enabled
                                                }
                                          )
                this.addEditCastCysEpithMode = 1 // 0 == add , 1 == edit 
                this.type_AddEditCastCysEpith = 'cystal' // 'cast','cystsl','epith
                this.isAddEditCastCysEpithShowing = true
        },





        loadEpithData(){
                this.isEpithLoading = true
                const datTo = {   
                                    "admin": true 
                               }
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/get_ua_epith_mst`,datTo,getConfigAxios())
                        .then((res)=>{
                              this.epithData = res.data
                              this.isEpithLoading = false
                        })
                        .catch((err)=>{
                            this.isEpithLoading = false
                            this.$buefy.dialog.alert({
                                title: 'Error',
                                message: `${err}`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'alert-circle',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                            this.$router.push('/login')
                                .catch(()=>{});
                        })
        },
        addNewEpith(){
                this.dataAddEditCastCysEpithToEdit = Object.assign({},
                                                                            {   
                                                                                "id" : null,
                                                                                "name": "" ,
                                                                                "enabled" : true 
                                                                            }
                                                                    )
                this.addEditCastCysEpithMode = 0 // 0 == add , 1 == edit 
                this.type_AddEditCastCysEpith = 'epith' // 'cast','cystal','epith
                this.isAddEditCastCysEpithShowing = true
        },
        editEpith(payload){
                this.dataAddEditCastCysEpithToEdit = Object.assign({},
                                                {   
                                                     "id" : payload.id,
                                                     "name": payload.name,
                                                     "enabled" : payload.enabled
                                                }
                                          )
                this.addEditCastCysEpithMode = 1 // 0 == add , 1 == edit 
                this.type_AddEditCastCysEpith = 'epith' // 'cast','cystsl','epith'
                this.isAddEditCastCysEpithShowing = true
        },













        close(){
           this.$emit('close')
        }
    },
    data(){
        return {
            isFullScreenLoading : false,
            isCastLoading : false,
            isCystalLoading : false,
            isEpithLoading : false,

            activeTab : 0,
            isEmpty : false,

            castData : [],
            cystalData : [],
            epithData : [],

            isAddEditCastCysEpithShowing : false,
            dataAddEditCastCysEpithToEdit: {},
            addEditCastCysEpithMode : 0 , // 0 == add , 1 == edit
            type_AddEditCastCysEpith : "",
        }
    },
    watch:{
        isComponentModalActive:{
            immediate: true,
            handler:function(val){
                 if(val){
                    
                    this.loadCastData()
                    this.loadCystalData()
                    this.loadEpithData()
                    
                    
                 }
            }
        }
    }
}
</script>